import { FETCH_CHART_DATA, LATEST_DATA } from "../actions/types";
import { get } from "lodash";

const INITIAL_STATE = {
  data: {
    battery: [
      {
        soc: 0,
        p: 0,
        state: 0
      }
    ],
    newBattery: [
      {
        soc: 0,
        p: 0,
        state: 0
      }
    ],
    pMax: [{ value: 0 }],
    pMaxOnPeak: [{ value: 0 }],
    pMaxOffPeak: [{ value: 0 }],
    meter_with_bess: [{ p: 0 }],
    meter_without_bess: [{ p: 0 }],
    pMaxLoadWithoutBess: [{ value: 0 }],
    pMaxLoad: [{ value: 0 }],
    setpoint: [{ p: 0 }],
    batteryBams: []
  },
  layout: {
    tariff: []
  }
};

const getLastNotNullValue = (state, ref, index = 1) => {
  const length = state.chartData.data[ref].length;

  const last = get(
    state.chartData.data[ref],
    `[${length - index}].value`,
    null
  );

  return (last === null) && (index < length) ?
    getLastNotNullValue(state, ref, index + 1) :
    last;
};

export const getLastPmax = state => getLastNotNullValue(state, 'pMax');

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_CHART_DATA:
      return { ...state, ...payload };

    case LATEST_DATA:
      const newState = { ...state };
      const data = { ...newState.data };

      data.battery.splice(0, 1);
      data.newBattery.splice(0, 1);
      data.pMax.splice(0, 1);
      data.pMaxOnPeak.splice(0, 1);
      data.pMaxOffPeak.splice(0, 1);
      data.meter_with_bess.splice(0, 1);
      data.meter_without_bess.splice(0, 1);
      data.pMaxLoadWithoutBess.splice(0, 1);
      data.pMaxLoad.splice(0, 1);
      data.setpoint.splice(0, 1);

      data.battery.push(payload.battery);
      data.newBattery.push(payload.newBattery);
      data.meter_with_bess.push(payload.meter_with_bess);
      data.meter_without_bess.push(payload.meter_without_bess);
      data.pMax.push(payload.pMax);
      data.pMaxOnPeak.push(payload.pMaxOnPeak);
      data.pMaxOffPeak.push(payload.pMaxOffPeak);
      data.pMaxLoadWithoutBess.push(payload.pMaxLoadWithoutBess);
      data.pMaxLoad.push(payload.pMaxLoad);
      data.setpoint.push(payload.setpoint);

      newState.data = data;
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/chart_data_reducer.js